"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const orderBy_1 = __importDefault(require("lodash/orderBy"));
const expandable_card_container_1 = __importDefault(require("../ExpandableCardContainer/expandable-card-container"));
const styles_1 = require("./styles");
const education_1 = __importDefault(require("./education"));
const board_certifications_1 = __importDefault(require("./board-certifications"));
const clinical_trials_1 = __importDefault(require("./clinical-trials"));
const messages_1 = __importDefault(require("../../lib/messages"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderExpertise = ({ provider, track }) => {
    const sortedTraining = (0, orderBy_1.default)(provider.training, ['graduation_year'], ['desc']);
    const sortedBoardCertifications = (0, orderBy_1.default)(provider.board_certifications, ['year_certified'], ['desc']);
    const sortedClinicalTrials = (0, orderBy_1.default)(provider.clinical_trials, ['start_date'], ['desc']);
    return (react_1.default.createElement(expandable_card_container_1.default, { id: "profile-expertise-section", track: track },
        react_1.default.createElement(styles_1.ExpertiseTitle, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.providerExpertiseTitle))),
        react_1.default.createElement(education_1.default, { training: sortedTraining }),
        react_1.default.createElement(board_certifications_1.default, { board_certifications: sortedBoardCertifications }),
        react_1.default.createElement(clinical_trials_1.default, { clinicalTrials: sortedClinicalTrials })));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProviderExpertise);
//# sourceMappingURL=provider-expertise.js.map